import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal } from 'react-bootstrap'
import { faTimes, faQuestion } from '@fortawesome/free-solid-svg-icons'
import { useRepToolContext } from '../../RepToolContext.tsx';
export const CloseButton = ({ closeModal }: { closeModal: Function }) => (
  <button type="button" className="close-btn button" onClick={() => { closeModal() }} aria-label="Close">
    <FontAwesomeIcon icon={faTimes} />
  </button>
)

const ModalTitle = ({
  title,
  closeModal,
  showCloseButton,
  showTutorial,
  layer
}: {
  title: string,
  closeModal: (() => void) | null,
  showCloseButton?: boolean,
  showTutorial?: Function,
  layer?: number
}) => {
  return (
    <div className="modal-header mb-3">
      <div className='d-flex flex-row w-100'>
        <h5 className="modal-title">{title}</h5>
        {showTutorial && <span className='py-2 text-light my-auto mx-4'>
          <FontAwesomeIcon icon={faQuestion} onClick={() => showTutorial()} />
        </span>}
      </div>
      {showCloseButton && closeModal && <button type="button" id={`close-${layer}`} className="close py-2" onClick={() => closeModal?.()} aria-label="Close">
        <FontAwesomeIcon icon={faTimes} />
      </button>}
    </div>
  )
}

export const ReptoolModal = ({
  id,
  title,
  body,
  closeModal,
  showTutorial,
  modalBodyClass = 'px-3',
  fullSize = false
}: {
  id?: string,
  title: string | ReactElement,
  body: ReactElement,
  closeModal: (() => void) | null,
  showTutorial?: () => void,
  modalBodyClass?: string,
  fullSize?: boolean
}) => {
  const [show, setShow] = useState<boolean>(true);
  const { setNumberOfActiveModals, appendControls } = useRepToolContext();
  useEffect(() => {
    if (!show) {
      appendControls(null, 'ReptoolModal');
      setTimeout(() => {
        closeModal?.()
      }, 1000);
    }
  }, [show])

  const numberOfActiveModals = useMemo(() => {
    const numberOfActiveModals = document.getElementsByClassName('modal slideInDown').length + 1;
    setNumberOfActiveModals(numberOfActiveModals);
    return numberOfActiveModals
  }, [setNumberOfActiveModals])


  return (
    <div id={id} className={`modal modal-layer-${numberOfActiveModals} animated  ${show ? 'slideInDown' : 'slideOutUp'}`}>
      {(title || closeModal) && <ModalTitle title={title} closeModal={() => setShow(false)} showCloseButton={!!closeModal} layer={numberOfActiveModals} showTutorial={showTutorial} />}

      <div className={`${modalBodyClass} reptool-modal-body ${fullSize ? '' : 'container'}`}>
        {body}
      </div>
    </div>
  )
}

export const ReptoolModal2 = ({
  id,
  title,
  body,
  closeModal,
  showTutorial,
  modalBodyClass = 'px-3'
}:
  {
    id?: string,
    title: string | ReactElement,
    body: ReactElement,
    closeModal: (() => void) | null,
    showTutorial?: () => void,
    modalBodyClass?: string
  }) => {
  const { setNumberOfActiveModals, appendControls } = useRepToolContext();
  const [show, setShow] = useState<boolean>(true);

  useEffect(() => {
    if (!show) {
      appendControls(null, 'ReptoolModal 2');
      setTimeout(() => {
        closeModal?.()
      }, 1000);
    }
  }, [show])
  const numberOfActiveModals = useMemo(() => {
    const numberOfActiveModals = document.getElementsByClassName('modal slideInDown').length + 1;
    setNumberOfActiveModals(numberOfActiveModals);
    return numberOfActiveModals
  }, [setNumberOfActiveModals])

  return (
    <Modal id={id} show={true} className={`modal-layer-${numberOfActiveModals} reptool-modal2 ${show ? 'slideInDown' : 'slideOutUp'}`} onHide={() => setShow(false)} size="lg" centered>
      {(title || closeModal) && <ModalTitle title={title} closeModal={() => setShow(false)} showCloseButton={!!closeModal} showTutorial={showTutorial} />}

      <Modal.Body>
        {body}
      </Modal.Body>
    </Modal>
  )
}